module.exports = __webpack_public_path__ + "static/media/bg-receitas.66fc95fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/BannerTop/bg-receitas.png
// module id = 302
// module chunks = 0